import { EnumTypeEtablissement, EnumTypeMedecin, EnumTypeService } from "./generated/Constants";


function isIE() {

    // BUG NORMALIZE
    var ua = window.navigator.userAgent;

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return true;
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        return true;
    }

    // other browser
    return false;
}

function tabContainString(tabStrings, word) {
    for (var j = 0; j < tabStrings.length; j++) {
        if (tabStrings[j].includes(word))
            return true
    }
    return false
}

export const HasWords = function (searchWords, searchData) {

    // Is internet explorer
    if (isIE()) {
        return true
    }

    let words1Tab = searchWords.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").split(" ")
    let words2Tab = searchData.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").split(" ")

    for (var i = 0; i < words1Tab.length; i++) {
        if (!tabContainString(words2Tab, words1Tab[i]))
            return false
    }
    return true
}

//// IMPORTANT : A NE SURTOUT PAS CHANGER !!! Modifie le référencement des pages
export const RemoveDiacritics = function (txt) {
    return txt.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
}

export const IsEmailValid = (email) => {
    if (!email)
        return false;

    return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};


export const FicheToRue = function (item) {
    return ((item.Ligne1 != null && (!item.Ligne1.isEmpty())) ? item.Ligne1 : '') + ((item.Ligne2 != null && (!item.Ligne2.isEmpty())) ? ' ' + item.Ligne2 : '')
}

export const FicheToString = function (item) {
    try {

        if (item.IdTypeFiche === 1)
            return 'Médecin - Dr. '
                + (item.Nom ? ' ' + item.Nom : '')
                + (item.Prenom ? ' ' + item.Prenom : '')
                + ' - ' + item.LibelleTypeEntite
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
                + ' Algérie'

        if (item.IdTypeFiche === 2)
            return (item.Libelle ? item.Libelle : '')
                + (item.LibelleTypeEntite ? ' - ' + item.LibelleTypeEntite : '')
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
                + ' Algérie'

        //if (item.IdTypeFiche === 3)
        return (item.Libelle ? item.Libelle : '')
            + (item.LibelleTypeEntite ? ' - ' + item.LibelleTypeEntite : '')
            + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
            + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
            + ' Algérie'

    } catch (e) {
        console.log("Exception meta FicheToString");
    }
}

export const FicheFullToString = function (item) {
    let res = ''
    try {


        if (item.IdTypeFiche === 1)
            return 'Médecin - Dr. '
                + (item.Nom ? ' ' + item.Nom : '')
                + (item.Prenom ? ' ' + item.Prenom : '')
                + ' - ' + item.LibelleTypeEntite
                + ' - Adresse : '
                + (item.Ligne1 ? ' ' + item.Ligne1 : '')
                + (item.Ligne2 ? ' ' + item.Ligne2 : '')
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
                + ' Algérie'

        if (item.IdTypeFiche === 2)
            return (item.Libelle ? ' ' + item.Libelle : '')
                + ' - ' + item.LibelleTypeEntite
                + ' - Adresse : '
                + (item.Ligne1 ? ' ' + item.Ligne1 : '')
                + (item.Ligne2 ? ' ' + item.Ligne2 : '')
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
                + ' Algérie'

        //if (item.IdTypeFiche === 3)
        return (item.Libelle ? ' ' + item.Libelle : '')
            + ' - ' + item.LibelleTypeEntite
            + ' - Adresse : '
            + (item.Ligne1 ? ' ' + item.Ligne1 : '')
            + (item.Ligne2 ? ' ' + item.Ligne2 : '')
            + ((item.Ville != null && (!item.Ville.isEmpty())) ? ' - ' + item.Ville : '')
            + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ' - ' + item.Wilaya : '')
            + ' Algérie'

    } catch (e) {
        console.log("Exception meta FicheFullToString");
    }
    return res
}

export const FicheToKeywords = function (item) {
    let res = ''
    try {

        if (item.IdTypeFiche === 1)
            return 'medecin, docteur, specialiste, sante, algerie'
                + (item.Nom ? ', ' + item.Nom : '')
                + (item.Prenom ? ', ' + item.Prenom : '')
                + (item.LibelleTypeEntite ? ', ' + item.LibelleTypeEntite : '')
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ', ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ', ' + item.Wilaya : '')
                + ', algerie'

        if (item.IdTypeFiche === 2)
            return 'etablissement, sante, algerie'
                + (item.Libelle ? ', ' + item.Libelle : '')
                + (item.LibelleTypeEntite ? ', ' + item.LibelleTypeEntite : '')
                + ((item.Ville != null && (!item.Ville.isEmpty())) ? ', ' + item.Ville : '')
                + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ', ' + item.Wilaya : '')
                + ', algerie'

        //if (item.IdTypeFiche === 3)
        return 'service, sante, algerie'
            + (item.Libelle ? ', ' + item.Libelle : '')
            + (item.LibelleTypeEntite ? ', ' + item.LibelleTypeEntite : '')
            + ((item.Ville != null && (!item.Ville.isEmpty())) ? ', ' + item.Ville : '')
            + ((item.Wilaya != null && (!item.Wilaya.isEmpty())) ? ', ' + item.Wilaya : '')
            + ', algerie'

    } catch (e) {
        console.log("Exception meta FicheToKeywords");
    }
    return res
}

export const IdStatutToString = function (paramItem) {

    let comment = ''
    if (paramItem.EstModifiee) {
        comment = ' (Modification en attente)'
    }

    switch (paramItem.Statut) {
        case 0:
            return 'Fiche désactivée' + comment
        case 1:
            return 'En attente de validation' + comment
        case 2:
            return 'Modification refusée' + comment
        case 3:
            return 'Fiche publiée' + comment
    }
}

export const getUrlFromIdTypeFiche = (idTypeFiche, idTypeMedecin, idTypeEtablissement, idTypeService) => {
    try {

        let item
        switch (idTypeFiche) {
            case 1:
                item = Object.values(EnumTypeMedecin).find(item => item.Code === idTypeMedecin)
                return '/medecin/type/' + item.Code + '/' + item.UrlFormate
            case 2:
                item = Object.values(EnumTypeEtablissement).find(item => item.Code === idTypeEtablissement)
                return '/etablissement/type/' + item.Code + '/' + item.UrlFormate
            case 3:
                item = Object.values(EnumTypeService).find(item => item.Code === idTypeService)
                return '/service/type/' + item.Code + '/' + item.UrlFormate
            default:
                return ''
        }

    } catch (e) {
        return ''
    }
}

export const getUrlFicheFromIdTypeFiche = (idFiche, idTypeFiche) => {
    switch (idTypeFiche) {
        case 1:
            return `/medecin/${idFiche}` 
        case 2:
            return `/etablissement/${idFiche}` 
        case 3:
            return `/service/${idFiche}` 
        default:
            return ''
    }
}

export const titleCase = (str) => {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
}


export const IdDayToStringShort = function (paramId) {
    switch (paramId) {
        case 1:
            return 'Lun'
        case 2:
            return 'Mar'
        case 3:
            return 'Mer'
        case 4:
            return 'Jeu'
        case 5:
            return 'Ven'
        case 6:
            return 'Sam'
        case 7:
            return 'Dim'
    }
}

export const IdDayToString = function (paramId) {
    switch (paramId) {
        case 1:
            return 'Lundi'
        case 2:
            return 'Mardi'
        case 3:
            return 'Mercredi'
        case 4:
            return 'Jeudi'
        case 5:
            return 'Vendredi'
        case 6:
            return 'Samedi'
        case 7:
            return 'Dimanche'
    }
}